import { defineComponent, createElementBlock, openBlock, createElementVNode, renderSlot, unref, createVNode } from "vue";
import { useColorMode } from "@scalar/use-hooks/useColorMode";
import _sfc_main$1 from "../components/FlowIcon.vue.js";
const _hoisted_1 = { class: "dark-light-toggle-layout" };
const _hoisted_2 = {
  key: 0,
  class: "dark-light-label"
};
const _hoisted_3 = {
  key: 1,
  class: "dark-light-label"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "DarkModeToggle",
  setup(__props) {
    const { toggleColorMode, isDarkMode } = useColorMode();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("button", {
          class: "dark-light-toggle",
          type: "button",
          onClick: _cache[0] || (_cache[0] = //@ts-ignore
          (...args) => unref(toggleColorMode) && unref(toggleColorMode)(...args))
        }, [
          createVNode(unref(_sfc_main$1), { icon: "LightDarkModeToggle" }),
          unref(isDarkMode) ? (openBlock(), createElementBlock("span", _hoisted_2, " Light Mode ")) : (openBlock(), createElementBlock("span", _hoisted_3, " Dark Mode "))
        ]),
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=DarkModeToggle.vue2.js.map
